import { BookingCalendarContext } from "../../../context/BookingCalendarContext";
import { useContext } from "react";
import styles from "./styles.module.css";
import { useTheme } from "../../../hooks/useTheme";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { className } from "../../../utils/styles";

export const CalendarHeader = () => {
  const { dates, currentDate, setCurrentDate } = useContext(
    BookingCalendarContext,
  );
  const { secondaryColor } = useTheme();
  const { t } = useTranslation();

  return (
    <header className={styles.container}>
      {dates.map((isoDate) => {
        const date = DateTime.fromISO(isoDate);
        const isSameDay = date.hasSame(DateTime.local(), "day");
        const isSelectedDate = date.hasSame(
          DateTime.fromISO(currentDate),
          "day",
        );
        return (
          <div
            data-testid="daySwitcher"
            className={className([
              styles.singleDate,
              isSelectedDate && styles.currentDate,
            ])}
            onClick={() => setCurrentDate(isoDate)}
            key={isoDate}
          >
            <span>
              {isSameDay ? t("calendar.today") : date.toFormat("LLL dd")}
            </span>
            <span className={styles.day} style={{ color: secondaryColor }}>
              {date.toFormat("EEE")}
            </span>
          </div>
        );
      })}
    </header>
  );
};
